export const getBlogUrl = (locale: string | undefined): string => {
  if (locale === 'cn') return '/cn/blog';
  if (locale === 'es') return '/es/blog';
  if (locale === 'fr') return '/fr/blog';
  if (locale === 'jp') return '/jp/blog';
  if (locale === 'kr') return '/kr/blog';
  if (locale === 'pt') return '/pt/blog';
  if (locale === 'ru') return '/ru/blog';
  if (locale === 'sa') return '/sa/blog';
  if (locale === 'tr') return '/tr/blog';
  return '/blog';
};
